import ImportRecords from './import-records.js';


export default class ImportUsers extends ImportRecords {


	constructor(params = {})
	{
		const defaults = { 
			container:   '.import-users',
			contents:    '.user-list',
			cached_key:  'queued-users',
			spinner_msg: 'Importing users...please wait',
			ajax_path:   '/admin/import/users/core/partials'
		}

		var p = { ...defaults, ...params };

		super(p);
	}


}